import { useEffect } from 'react';
import { getPeriod, prepareAndGetChatType } from '../../../helpers/StatsHelpers';
import { useFilters } from '../../../contexts/filters/FiltersContext';
import { AccountResponse } from '../../../models/account/AccountResponse';

const useMonitorPeriodAndChatType = (
  type: string | undefined,
  period: string | undefined,
  chat: string | undefined,
  projectId: number,
  accountResponse: AccountResponse | null
) => {
  const { monitorPeriod, setMonitorPeriod, selectedChatType, setSelectedChatType } = useFilters();

  useEffect(() => {
    const newMonitorPeriod = getPeriod(period);
    const selectedChatType = prepareAndGetChatType(accountResponse, 'ALL', chat);
    setMonitorPeriod(newMonitorPeriod);
    setSelectedChatType(selectedChatType);
  }, [type, period, chat]);

  return { monitorPeriod, selectedChatType };
};

export default useMonitorPeriodAndChatType;
